import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { Link } from 'gatsby'
import { deviceMin } from '../../theme/breakpoints'

export const StyledDropdownItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${pxToRem(24)};
  text-align: left;

  @media ${deviceMin.laptop} {
    font-size: ${({ theme }) => theme.fonts.sizes.titleH3.laptop};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
  }

  & .subitems li {
    @media ${deviceMin.laptop} {
      font-size: ${({ theme }) => theme.fonts.sizes.titleH4.laptop};
      font-weight: ${({ theme }) => theme.fonts.weight.light};
    }
  }
`

export const StyledDropdownSubItem = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(14)};
`

export const StyledLink = styled(Link)`
  &:hover,
  &[aria-current] {
    text-decoration: underline;
    text-underline-offset: ${pxToRem(6)};
    text-decoration-thickness: ${pxToRem(2)};
    text-decoration-color: ${({ theme }) => theme.colors.primary.blue};
  }
`
